<div class="card card-secondary card-outline mb-0" cdkDragBoundary="html" cdkDrag
    cdkDragRootElement=".cdk-overlay-pane">
    <div class="card-header bg-light" cdkDragHandle>
        <div class="cabecalho-textos">
            <h4 class="titulo-historico">Histórico de Alterações</h4>
            <div class="subtitulo-historico">
                Ação {{ identificador }}<span *ngIf="tituloAcao"> · {{ tituloAcao }}</span>
            </div>
        </div>
        <div class="card-tools">
            <button type="button" class="btn btn-tool" (click)="fechar()">
                <i class="fas fa-times"></i>
            </button>
        </div>
    </div>

    <div class="card-body">
        <!-- Filtros e interruptor -->
        <div class="row mb-3 align-items-end">
            <div class="col-md-4">
                <label class="mb-1">Campo alterado</label>
                <ng-select [(ngModel)]="campoFiltro" (change)="carregar()" placeholder="Todos os campos"
                    [clearable]="true" [ngModelOptions]="{standalone: true}">
                    <ng-option *ngFor="let c of campos" [value]="c">{{ c }}</ng-option>
                </ng-select>
            </div>
            <div class="col-md-5">
                <label class="mb-1">Responsável</label>
                <ng-select [(ngModel)]="responsavelFiltro" (change)="carregar()" placeholder="Todos os responsáveis"
                    [clearable]="true" [ngModelOptions]="{standalone: true}">
                    <ng-option *ngFor="let r of responsaveis" [value]="r.value">{{ r.text }}</ng-option>
                </ng-select>
            </div>
            <div class="col-md-3 text-right">
                <div class="btn-group btn-group-sm" role="group">
                    <button type="button" class="btn" [ngClass]="modo === 'tabela' ? 'btn-primary' : 'btn-default'"
                        (click)="alterarModo('tabela')">Tabela</button>
                    <button type="button" class="btn" [ngClass]="modo === 'timeline' ? 'btn-primary' : 'btn-default'"
                        (click)="alterarModo('timeline')">Linha do tempo</button>
                </div>
            </div>
        </div>

        <div class="conteudo-historico">
            <!-- TABELA -->
            <div *ngIf="modo === 'tabela'" class="table-responsive">
                <table class="table table-sm table-hover mb-0">
                    <thead class="bg-light">
                        <tr>
                            <th>Data / Hora</th>
                            <th>Campo alterado</th>
                            <th>Valor anterior</th>
                            <th>Valor atual</th>
                            <th>Responsável</th>
                            <th class="text-center">Operação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let l of historico.linhas">
                            <td class="text-nowrap">
                                {{ l.dataHora | date: 'dd/MM/yyyy' }}<br>
                                <small class="text-muted">{{ l.dataHora | date: 'HH:mm' }}</small>
                            </td>
                            <td><strong>{{ l.campo }}</strong></td>
                            <td class="valor anterior">
                                <span *ngIf="!l.valorAnterior">—</span>
                                <div *ngIf="l.valorAnterior" [innerHTML]="l.valorAnterior"></div>
                            </td>
                            <td class="valor">
                                <span *ngIf="!l.valorAtual">—</span>
                                <div *ngIf="l.valorAtual" [innerHTML]="l.valorAtual"></div>
                            </td>
                            <td>{{ l.responsavelNome }}</td>
                            <td class="text-center">
                                <span class="badge" [ngClass]="classeOperacao(l.operacao?.codigo)">
                                    {{ l.operacao?.descricao }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <h5 class="table-no-data" [hidden]="historico.linhas?.length > 0">Nenhum registro encontrado</h5>
            </div>

            <!-- LINHA DO TEMPO -->
            <div *ngIf="modo === 'timeline'" class="linha-tempo">
                <h5 class="table-no-data" [hidden]="grupos.length > 0">Nenhum registro encontrado</h5>

                <div class="grupo" *ngFor="let g of grupos">
                    <div class="grupo-data">
                        <strong>{{ g.dataHora | date: 'dd/MM/yyyy' }}</strong>
                        <small class="text-muted">{{ g.dataHora | date: 'HH:mm' }}</small>
                    </div>
                    <div class="grupo-marcador"></div>
                    <div class="grupo-corpo">
                        <div class="grupo-titulo">
                            <strong>{{ g.responsavelNome }}</strong>
                            <span class="text-muted"> {{ rotuloAlteracoes(g.linhas.length) }}</span>
                        </div>
                        <div class="alteracao" *ngFor="let l of g.linhas">
                            <div class="alteracao-campo">
                                {{ l.campo }}
                                <span class="badge ml-1" [ngClass]="classeOperacao(l.operacao?.codigo)">
                                    {{ l.operacao?.descricao }}
                                </span>
                            </div>
                            <div class="alteracao-valores">
                                <span class="anterior" *ngIf="l.valorAnterior" [innerHTML]="l.valorAnterior"></span>
                                <span class="anterior" *ngIf="!l.valorAnterior">—</span>
                                <span class="seta">→</span>
                                <span class="atual" *ngIf="l.valorAtual" [innerHTML]="l.valorAtual"></span>
                                <span class="atual" *ngIf="!l.valorAtual">—</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card-footer d-flex align-items-center">
        <small class="text-muted">
            <span *ngIf="historico.criadoEm">
                Registro criado em {{ historico.criadoEm | date: 'dd/MM/yyyy HH:mm' }}
                <span *ngIf="historico.criadoPorNome">por {{ historico.criadoPorNome }}</span>
            </span>
        </small>
        <button type="button" class="btn btn-primary btn-sm ml-auto" (click)="fechar()">Fechar</button>
    </div>
</div>